export default __webpack_public_path__ + "static/media/etherealescape.6d0d4a66.png";